import { defineRecipe } from '@chakra-ui/react';

export const textRecipe = defineRecipe({
  base: {
    fontSize: 'sm',
    color: 'lightning.900',
  },
});
